<template>
    <div>
        <el-form size="small" label-position="left" label-width="100px" class="lywidgetsetting" @submit.prevent>
            <el-collapse v-model="lyCollapseActiveList" class="lyformsetting-collapse">
                <el-collapse-item name="lyws01" title="组件属性">
                    <el-form-item label="字段标识">
                        <el-input  v-model.trim="optionModel.name" @change="handleChange"></el-input>
                    </el-form-item>
                    <el-form-item label="隐藏">
                        <el-switch v-model="optionModel.hidden" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="禁用">
                        <el-switch v-model="optionModel.disabled" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="标签文本">
                        <el-input v-model="optionModel.label"  style="width: 100%" @change="handleChange"></el-input>
                    </el-form-item>
                    <el-form-item label="标签宽度">
                        <el-input v-model="optionModel.labelWidth"  style="width: 100%" @change="handleChange"></el-input>
                    </el-form-item>
                    <el-form-item label="隐藏字段标签">
                        <el-switch v-model="optionModel.labelHidden" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="必填字段">
                        <el-switch v-model="optionModel.required" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="必填校验提示">
                        <el-input v-model="optionModel.requiredHint"  style="width: 100%" @change="handleChange"></el-input>
                    </el-form-item>
                    <customClassLy :selected-widget="selectedWidget" :option-model="optionModel"></customClassLy>
                    <el-form-item label-width="0">
                            <el-divider>上传参数设置</el-divider>
                    </el-form-item>
                    <el-form-item label="是否拖拽上传">
                        <el-switch v-model="optionModel.draggable" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="文件可多选">
                        <el-switch v-model="optionModel.multipleSelect" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="上传ICON">
                        <el-input v-model="optionModel.uploadIcon"  style="width: 100%" @change="handleChange"></el-input>
                    </el-form-item>
                    <el-form-item label="上传标题内容">
                        <el-input v-model="optionModel.uploadTitle"  style="width: 100%" @change="handleChange"></el-input>
                    </el-form-item>
                    <el-form-item label="上传提示内容">
                        <el-input v-model="optionModel.uploadTip"  style="width: 100%" @change="handleChange"></el-input>
                    </el-form-item>
                    <el-form-item label="最大上传数量">
                        <el-input-number v-model="optionModel.limit" :min="1" :max="100" style="width: 100%" @change="handleChange"></el-input-number>
                    </el-form-item>
                    <el-form-item label="大小限制(MB)">
                        <el-input-number v-model="optionModel.fileMaxSize" :min="1" :max="1000" style="width: 100%" @change="handleChange"></el-input-number>
                    </el-form-item>
                    <el-form-item>
                        <template #label>
                            <span>文件类型
                                <el-tooltip effect="dark" content="支持添加其他类型">
                                <el-icon><InfoFilled /></el-icon>
                                </el-tooltip>
                            </span>
                        </template>
                        <el-select multiple allow-create filterable default-first-option v-model="optionModel.fileTypes" style="width: 100%" @change="handleChange">
                            <el-option v-for="(ft, ftIdx) in uploadFileTypes"
                                     :key="ftIdx"
                                     :label="ft.label"
                                     :value="ft.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="按钮颜色">
                        <el-select v-model="optionModel.buttonType" filterable @change="handleChange">
                            <el-option label="default" value=""></el-option>
                            <el-option label="primary" value="primary"></el-option>
                            <el-option label="success" value="success"></el-option>
                            <el-option label="warning" value="warning"></el-option>
                            <el-option label="danger" value="danger"></el-option>
                            <el-option label="info" value="info"></el-option>
                            <el-option label="text" value="text"></el-option>
                        </el-select>
                    </el-form-item>
                </el-collapse-item>
                <el-collapse-item name="lyws03" title="CRUD属性" v-if="builderConfig.showCrudSettings">
                    <template #title>
                        <div style="display: flex;align-items: center;">
                            CRUD属性
                            <el-tooltip effect="dark" content="后端自动生成CRUD代码，用于控制是否列表显示、可查询、可空、可编辑等属性" placement="top-start">
                                <el-icon><QuestionFilled /></el-icon>
                            </el-tooltip>
                        </div>
                    </template>
                    <crudCommonLy :selected-widget="selectedWidget" :option-model="optionModel"></crudCommonLy>
                </el-collapse-item>
            </el-collapse>
        </el-form>
    </div>
</template>

<script setup>
    import {ref, onMounted, reactive, computed, watch} from 'vue'
    import { useBuilderStore } from "@/store/lyFormBuilder";
    import validationCommonLy from "@/components/lyform-builder/lysetting-pannel/lywidget-common/validation-common-ly"
    import customClassLy from "@/components/lyform-builder/lysetting-pannel/lywidget-common/custom-class-ly"
    import crudCommonLy from "@/components/lyform-builder/lysetting-pannel/lywidget-common/crud-common-ly"
    const props = defineProps({
        selectedWidget: Object,
        optionModel: Object,
        builderConfig :{
            type:Object,
            default:{
                showHeader:true,//是否显示头部信息
                showFormTemplates:true,//是否显示表单模板
                showEventCollapse:true,//是否显示组件事件属性折叠面板
                showDocumentButton:true,//是否显示文档按钮
                clearDesignerButton: true,  //是否显示清空设计器按钮
                previewFormButton: true,  //是否显示预览表单按钮
                exportJsonButton: true,  //是否显示导出JSON器按钮
                exportCodeButton: true,  //是否显示导出代码按钮
                importJsonButton:true, //是否显示导入代码按钮
                showFullButton: true,  //是否显示全屏按钮
                openNewWindowButton: true,  //是否显示新窗口按钮
                saveFormButton:true, //是否保存表单按钮
                showCrudSettings:true,//是否显示组件和表单的crud属性配置
            }
        },
    })
    const builderStore = useBuilderStore()
    function handleChange(newValue) {
         builderStore.saveCurrentHistoryStep()
    }
    let lyCollapseActiveList =  ref(['lyws01','lyws02','lyws03'])
    const formSizes = ref([
        {label: 'default', value: ''},
        {label: 'large', value: 'large'},
        {label: 'small', value: 'small'},
    ])
    const uploadFileTypes = ref([
      {value: '.doc', label: '.doc'},
      {value: '.xls', label: '.xls'},
      {value: '.docx', label: '.docx'},
      {value: '.xlsx', label: '.xlsx'},
    ])
    function showEventCollapse(){
        if (builderStore.builderConfig['showEventCollapse'] === undefined) {
          return true
        }
        return !!builderStore.builderConfig['showEventCollapse']
    }
    function editFormEventHandler(flag){

    }

</script>

<style lang="scss" scoped>
    .lywidgetsetting{
        ::v-deep(.el-form-item__label) {
          font-size: 13px;
          overflow: hidden;
          white-space: nowrap;
        }
        .lyformsetting-collapse{
            ::v-deep(.el-collapse-item__header) {
                font-weight: bold;
            }
        }
    }

</style>